import { key as firebaseKey } from 'firebase-key'

export function key(name: string): string {
    return `${name}${firebaseKey()}`
}

export function openNewTab(url: string): void {
    window.open(url)
}